
import React, { useState, FormEvent, ChangeEvent, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Section from './ExperienceForms';
import { getApplicationExistencCheck, submitEnclosureFiles, submitWorkExperiencePanel } from '../../auth/services/privateapicalling';
import  {setExperienceData , setWorkPerformance ,setConstructionData }  from '../../../core/data/redux/authSlice';
import { set } from 'lodash';
import * as Yup from "yup";
import ExperienceEdit from './ExperienceEditModal';
import { toast,ToastContainer } from "react-toastify";
import "bootstrap/dist/js/bootstrap.bundle.min"; 
declare const bootstrap: any;


interface ExperienceProps {
  onNext: (data: any) => void;
  onPrev: () => void;
  existData:any;
  onAdd:()=>void;
  isExperienceFilled:boolean;
  fetchApplicationExistenceCheck:() => void;
}

const ExperienceForm: React.FC<ExperienceProps> = ({ onNext, onPrev , existData ,fetchApplicationExistenceCheck, onAdd , isExperienceFilled}) => {

  const token = useSelector((state: any) => state.auth.token);
  const [isLoading, setIsLoading] = useState(false);
  const [isUploading, setIsUploading] = useState(false);
  
  const language = useSelector((state: any) => state.auth.language);
  const formLanguage = useSelector((state: any) => state.auth.formLanguage);

  const userdetails = useSelector((state: any) => state.auth.userDetails);
  
  //  Separate State for each section
  
  const standard = existData?.eduQualification.find(data=>data.standard=="mastersDegree" || data.standard=="phd" )?.standard;


  let requiredExperience = (standard =="mastersDegree" || standard=="phd" ) ? 4 : 5;
  



  const [experienceList, setExperienceList] = useState<any[]>([]);
  const [workPerformedList, setWorkPerformedList] = useState<any[]>([]);
  const [doneConstructionList, setDoneConstructionList] = useState<any[]>([]);
  const [itReturn , setItReturn] = useState< File | null >(null);
   const [yoe , setYoe] = useState<string | null>()
  const [docCountExperience , setDocCountExperience] = useState<number>(0);
  const [docCountWork , setDocCountWork] = useState<number>(0);
  const [docCountConstruction , setDocCountConstruction] = useState<number>(0);
  const [itReturnDet, setItReturnDet] = useState<any>({});
  const [error, setError] = useState<string | null>(null);
  const [buserror, setBusError] = useState<string | null>(null);

  const [isExperienceListSubmitted, setIsExperienceListSubmitted] = useState(false);
  const [isWorkPerformedListSubmitted, setIsWorkPerformedListSubmitted] = useState(false);
  const [isDoneConstructionListSubmitted, setIsDoneConstructionListSubmitted] = useState(false);
  const [isItReturnSubmitted, setIsItReturnSubmitted] = useState(false);
  const [selectedExperience, setSelectedExperience] = useState<any>(null);
  const [modalId, setModalId] = useState<string>("");
  const [listToUpdate, setListToUpdate] = useState<any[]>([]);
  const [onChangeCallback, setOnChangeCallback] = useState<((values: string[]) => void) | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modelToUpdate, setModelToUpdate] = useState<string>("");
  const [isExpLoading, setIsExpLoading] = useState(false);
  const [isWorkPLoading, setIsWorkPLoading] = useState(false);
  const [isConstloading, setIsConstLoading] = useState(false);
  
    const  [isAllowed,setIsAllowed] = useState(true);

    const [itReturnDetail, setItReturnDetail] = useState<any[]>(
      existData?.itReturnDetail?.length > 0 ? existData.itReturnDetail : []
    );



  const dispatch = useDispatch();
  //  Handle updates independently
  const handleExperienceChange = (values: any[]) => {
    //.log('vvvvvvvvvv', values)
    setExperienceList(values);

    dispatch(setExperienceData(values));
    const data={
      expList :values
    }
    submitExperienceforPanel(data);

    // handleNext();
  };
 
  const yoeSchema = Yup.number()
  .typeError("Years of experience must be a number")
  .required("This field is required")
  .positive("Value must be positive")
  .integer("Value must be a whole number")
  .min(
    requiredExperience,
    `A minimum of ${requiredExperience} years of relevant experience is required.`
  )
  .max(49, "Please enter a maximum of 2 digits (less than 50).");

  


const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value ? e.target.value : null;
    setYoe(value);

    // Validate input
    yoeSchema
      .validate(value)
      .then(() => setBusError(null)) // No errors
      .catch((err) => setBusError(err.message)); // Set error message
  };
  

  const handleWorkPerformedChange = (values: any[]) => {
    setWorkPerformedList(values);
    const workPerform = values;

    dispatch(setWorkPerformance(values));
    const data={
      perfList :values
    }
    submitExperienceforPanel(data);

    // handleNext();

  };

  const handleConstructionChange = (values: any[]) => {
    setDoneConstructionList(values);
    const construct = values;
  
    dispatch(setConstructionData(values));
    const data={
      constList :values
    }
    submitExperienceforPanel(data);

  };

  const [itReturns, setItReturns] = useState({
    itReturns_1: existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_1`) ? existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_1`)?.fileName: null,
    itReturns_2: existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_2`) ? existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_2`)?.fileName: null,
    itReturns_3: existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_3`) ? existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_3`)?.fileName: null,
  });
  
 
const fileSchema = Yup.mixed()
  .nullable()
  .test(
    "required-check",
    "IT return file is required",
    (value) => {
      // If nothing is present
      if (!value) return false;

      // Accept plain string (for pre-filled filenames)
      if (typeof value === "string" && value.trim() !== "") return true;

      // Accept File instance (new upload)
      if (value instanceof File) return true;

      // ✅ Type guard to check if value is an object with a fileName string
      if (
        typeof value === "object" &&
        value !== null &&
        "fileName" in value &&
        typeof (value as any).fileName === "string"
      ) {
        return true;
      }

      return false;
    }
  );




  const [disableButtonNext, setDisableButtonNext] = useState(false);


const validateITReturns = async (files: any) => {
  const errors: any = {};

  for (const key of ["itReturns_1", "itReturns_2", "itReturns_3"]) {
    try {
      await fileSchema.validate(files[key]);
    } catch (err: any) {
      errors[key] = err.message;
      setError(err.message); // show the first error
    }
  }

  // ✅ Clear errors if no validation errors
  if (Object.keys(errors).length === 0) {
    setError(""); // or setError(null) if you prefer
    return null;
  }

  return errors;
};


  const handleItReturnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {

    const { name ,files } = e.target;
    if (files && files.length > 0) {
      const file = files[0];
      // setItReturns((prev) => ({ ...prev, [name]: files[0] }));
      // setDisableButtonNext(true)
      uploadItReturn(file,name);
      // setDisableButtonNext(false)
    }
  };

  const uploadItReturn = async(file:any,name:any)=>{ 
    try {                                                                   
      setIsUploading(true);
      setDisableButtonNext(true)
      const uploadData = new FormData();
   

      uploadData.append("file", file as Blob);
      uploadData.append("documentName", name);
      uploadData.append("applicationId", existData.applicationId);

       let existingDocId = null;
        const itReturnStateValue = itReturns[name];
        if (itReturnStateValue && itReturnStateValue?.docId && typeof itReturnStateValue === 'object' ) {
          existingDocId = itReturnStateValue.docId;
        }
      

       
         if (!existingDocId) {
      const existingDoc = existData && existData.docs?.find((doc: any) => doc.documentName === name);
      
      existingDocId = existingDoc?.id || null;
    }
  
      const uploadDoc = await submitEnclosureFiles(uploadData , token ,  existingDocId);
        
      //.log('submitted edu ress' , uploadDoc);
      if(uploadDoc.success==true)
        {  
          const itreturn = {
            docId:uploadDoc.data?.id,
            documentName:name,
            fileName:uploadDoc.data?.fileName,
          }
          
          let dataArray = []
          // data.push(itreturn)
          // setItReturnDetail((prev) => {
            const existingIndex = existData.itReturnDetail.findIndex((item:any) => item.docId === itreturn.docId);
        
            if (existingIndex !== -1) {
              // Override the existing item
              const updated = [...existData.itReturnDetail];
              updated[existingIndex] = itreturn;
              dataArray = [...updated]
              
            } else {
              // Add new item
              dataArray = [...existData.itReturnDetail, itreturn]
             }
            // }})
            let dataa ={itr :dataArray}

          submitExperienceforPanel(dataa);
          fetchApplicationExistenceCheck();
          setItReturnDet(itreturn)
           setItReturns((prev) => ({ ...prev, [name]: itreturn }));
      
        
          onAdd();

          
        }else if(uploadDoc.success==false){
          toast.error(`${uploadDoc.message}`)
        }
        setDisableButtonNext(false)
    } catch (error) {
      //.log('error', error)
    } finally{
      setIsUploading(false);
    }

}

  const submitExperienceforPanel = async(body:any)=>{


    const data = {
      experienceDetail: body?.expList ?? experienceList, // Use expList if present, otherwise fallback
      govSemiGovExpDetail: body?.perfList ?? workPerformedList, // Use perfList if present, otherwise fallback
      marketPublicConstructionDetail: body?.constList ?? doneConstructionList,
      yrOfExpAsBusErr:yoe,
      itReturnDetail:body.itr,
      applicationId:existData.applicationId
    }


    try {
      setIsLoading(true);
     const res = await submitWorkExperiencePanel(data , token)
      //.log('res', res)
      if(res.success==true)
        setIsExpLoading(false)
        setIsWorkPLoading(false)
        setIsConstLoading(false)
        toast.success(res.message,{ position: "top-right", autoClose: 3000,})
        setIsModalOpen(false);
        onAdd();
        // onNext("")
    } catch (error) {
      //.log('error', error)
    } finally{
      setIsLoading(false);
    }
  }


  const handleNext = async () => {
 
      const validationErrors = await validateITReturns(itReturns);
    
      if(Object.keys(validationErrors || {}).length > 0) {                                
        return
      }

      if(yoe=="" || yoe==null || yoe=='0')
      {
        showErrorToast(`Minimum of ${requiredExperience} Business year of experience is required`)
        return;
      }

  if (existData?.experienceDetail?.length > 0 &&  Object.keys(existData.itReturnDetail).length > 0 ) {


       if(buserror==null)
       {
        submitExperienceforPanel(yoe);
        onNext(" ");

       }
       else{
        showErrorToast(`A minimum of ${requiredExperience} years of relevant experience is required.`)
       }

      }
      else {
        showErrorToast("Please fill all the experience details.");
        
        }

  };

  const panelExperiencelMapping = {
    experienceDoc:"Experience",
    workPerformanceDoc:"Work Performance",
    constructionDocs:"Construction",
 
  }

 const handleEditClick = (entry: any, modalId: string , list:any[] , docName:string ) => {
 
    setListToUpdate(list);
    setSelectedExperience(entry);
    setModalId(modalId); 
    setModelToUpdate(docName)
    setIsModalOpen(true);
  };
  
  const handleOncallbackChange = (values: any[] ) => {
  

  (  modelToUpdate && modelToUpdate == "experienceDoc") ? handleExperienceChange(values) : (modelToUpdate == "workPerformanceDoc" ? handleWorkPerformedChange(values) : handleConstructionChange(values))
    
  

  }

   const validationSchema = Yup.object().shape({
      projectName: Yup.string().matches(/^[A-Za-z0-9\s]+$/, "Project name cannot contain special characters").
      required("Project name is required").max(50, "Project name cannot exceed 50 characters"),
  
      startDate: Yup.string()
    .required("Start date is required")
    .test("not-future", "Start date cannot be in the future", function (value) {
      return new Date(value!) <= new Date(); // Ensures the start date is not in the future
    }),
  
  endDate: Yup.string()
    .required("End date is required")
    .test("is-after-start", "End date must be after start date", function (value) {
      return new Date(value!) > new Date(this.parent.startDate); // Ensures end date is after start date
    })
    .test("not-future", "End date cannot be in the future", function (value) {
      return new Date(value!) <= new Date(); // Ensures the end date is not in the future
    })
    ,
  
        evidence: Yup.mixed()
        .required("Evidence file is required.")
        .test("file-required", "Evidence file is required.", function (value) {
          return value != null;
        })
        .test("fileFormat", "Only PDF, JPG, and JPEG files are allowed.", function (value) {
          if (!value) return false;
          const allowedFormats = ["application/pdf", "image/jpeg", "image/jpg"];
          return value instanceof File && allowedFormats.includes(value.type);
        })
        .test("fileSizeMax", "File size must be less than 3MB.", (value) => {
          if (!value || !(value instanceof File)) return false;
          return value.size <= 3 * 1024 * 1024; // 3 MB
        })
        .test("fileSizeMin", "File size must be at least 40KB.", (value) => {
          if (!value || !(value instanceof File)) return false;
          return value.size >= 40 * 1024; // 50 KB
        })
      
    });

    const toastCooldown = useRef(false);
  
    const showErrorToast = (message: string) => {
      if (toastCooldown.current) return; // Skip if still in cooldown
    
      toast.error(message, { position: "top-right", autoClose: 3000 });
      toastCooldown.current = true;
    
      // Reset cooldown after 3 seconds
      setTimeout(() => {
        toastCooldown.current = false;
      }, 3000);
    };

  useEffect(()=>{
    //.log('existttdataaa', existData)
    const expDet = existData.experienceDetail;
    //.log('expDet', expDet)
    setExperienceList(expDet);
    setWorkPerformedList(existData.govSemiGovExpDetail);
    setDoneConstructionList(existData.marketPublicConstructionDetail);
    setYoe(existData.yrOfExpAsBusErr)
    setItReturnDet(existData.itReturnDetail)
   },[existData])

  return (
    <>
     <div className="container mt-4">
      
      <div className="card">
          <div className="card-header">
            <h6 className="card-title">{language.enter_details}</h6>
          </div>
          <div className="card-body">
      {/*  Experience Section */}
      <h6 className='mb-3'>{formLanguage.h_experience_details}</h6>
      <h6 className='mb-3'> {language.h_experience_details}</h6>

      <Section
        title={language.experience_details}
        list={experienceList}
        setList={setExperienceList}
        onChange={handleExperienceChange}
        docName="experienceDoc"
        existData={existData}
        count={docCountExperience}
        onAdd={onAdd}
        onEditClick={handleEditClick}
        modalId="edit_exp1"
        loading={isExpLoading}
        setLoading={setIsExpLoading}
      />

        <div className="card col-md-6 mb-3 p-2">
        
        <label className="form-label">
        {formLanguage.business_engineer} ({language.business_engineer}) <span className="text-danger">*</span>
      </label>
      <input
  type="number"
  className={`form-control ${buserror ? "is-invalid" : ""}`}
  value={yoe ?? ""}
  onChange={(e) => {
    const value = e.target.value;
    if (value.length <= 2) {
      handleChange(e);
    }
  }}
  onWheel={(e) => e.currentTarget.blur()}
  min={0}
  max={99}
/>
      {buserror && <div className="text-danger">{buserror}</div>}
                
         </div>

      {/*  Work Performed Section */}
      <h6 className='mb-3'> ({formLanguage.h_work_performed})</h6>
      <h6 className='mb-3'> ({language.h_work_performed})</h6>
      <Section
        title={language.work_performed}
        list={workPerformedList}
        setList={setWorkPerformedList}
        onChange={handleWorkPerformedChange}
        docName="workPerformanceDoc"
        existData={existData}
        count={docCountWork}
        onAdd={onAdd}
        onEditClick={handleEditClick}
        modalId="edit_exp1"
        loading={isWorkPLoading}
        setLoading={setIsWorkPLoading}
        
      />

      {/*  Done Construction Section */}
      <h6 className='mb-3'>{formLanguage.h_done_construction}</h6>
      <h6 className='mb-3'>({language.h_done_construction})</h6>

      <Section
        title={language.done_construction}
        list={doneConstructionList}
        setList={setDoneConstructionList}
        onChange={handleConstructionChange}
        docName="constructionDocs"
        existData={existData}
        count= {docCountConstruction}
        onAdd={onAdd}
        onEditClick={handleEditClick}
        modalId="edit_exp3"
        loading={isConstloading}
        setLoading={setIsConstLoading}
        />
       <div className="col-md-6">
      <label className="form-label">
       {formLanguage.it_returns} ({language.it_returns}) <span className="text-danger">*</span>
      </label>
      <p className="text-danger mb-1">{language.file_type}</p>
    {(() => {
   const today = new Date();
   const currentYear = today.getFullYear();
   const july31 = new Date(currentYear, 6, 31); // July is month 6 (0-based index)
   const fiscalStartCutoff = new Date(currentYear, 6, 31);
 
   // If today is after July 31, start from current FY
   const endYear = today <= july31 ? currentYear - 1 : currentYear;
 
   const fiscalYears = [];
   for (let i = 0; i < 3; i++) {
     const fyEnd = endYear - i;
     const fyStart = fyEnd - 1;
     fiscalYears.push(`FY ${fyStart}-${fyEnd}`);
   }
  
  return fiscalYears.map((label, index) => (
    <div className="mb-3 flex flex-column" key={index}>
      <label><strong>{index + 1}. {label}</strong></label>
      {/* <p className="text-danger mb-1">{language.file_type}</p> */}
      <input
        type="file"
        name={`itReturns_${index + 1}`}
        disabled={disableButtonNext}
        className={`form-control ${error ? "is-invalid" : ""}`}
        accept=".pdf, .jpg, .jpeg"
        onChange={handleItReturnChange}
      />
      
      {existData?.itReturnDetail?.length > 0 && (
        <div className="mt-2">
           Uploaded: {existData && existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_${index + 1}`)?.fileName}
        </div>
      )}
      {/* {(itReturns[`itReturns_${index + 1}`] instanceof File || !existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_${index + 1}`)?.fileName) &&
  error && <div className="text-danger">{error}</div>} */}

      {!existData?.itReturnDetail?.find((doc: any) => doc.documentName === `itReturns_${index + 1}`)?.fileName &&
  error && <div className="text-danger">{error}</div>}
      {/* {error && <div className="text-danger">{error}</div>} */}
    </div>
  ));
  })()}

    
    </div>

      {/* Navigation Buttons */}
      <div className="d-flex justify-content-between mt-4">
        <ToastContainer position="top-center" autoClose={3000} />
        
        <button type="button" className="btn btn-secondary" onClick={onPrev}>
          {language.previous}
        </button>
        <button type="button" className="btn btn-primary"
        disabled={disableButtonNext}
         onClick={handleNext}
         >
         
          {disableButtonNext && (
          <i className="ion-load-a ion-spin"> </i> 
        )}
        {language.next}
        </button>
      </div>
    </div>
    </div>            
    {(isUploading || isLoading) && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-25"
          style={{ zIndex: 9999 }}
        >
          <div className="d-flex align-items-center px-4 py-3 bg-white rounded shadow">
            <div
              className="spinner-border text-primary me-3"
              role="status"
            />
            <span className="fw-semibold text-dark">
              {isUploading ? "Uploading" : "Submitting"}...
            </span>
          </div>
        </div>
      )}
    </div>
     <ExperienceEdit  isOpen={isModalOpen}  onClose={() => setIsModalOpen(false)} selectedExperience={selectedExperience} modalId={modalId} 
    appId={existData.applicationId} listToUpdate={listToUpdate} onChangeCallback={handleOncallbackChange} validationSchema={validationSchema} />
    </>
   
  );
};

export default ExperienceForm;
